<template>
    <!--
        Bekleyen Referans Grupları (Task 1)

        Sefer İşlemleri altında, Sefer ekranının kardeşi. Sefer ekranı "bir cari + şube ver,
        seni gruplanmamış seferler için hazırlayayım" derken bu ekran tersi soruyu cevaplıyor:
        "hangi cari + şube + hafta kombinasyonunda hâlâ grup açılmamış?"

        Adam kullanıcının sıkıntısı şuydu: bugün her cari + her şube için tek tek Filtrele'ye
        basıp bakması gerekiyor; bir kombinasyon atlanırsa o haftanın hakedişi açılmadan kalıyor
        ve kimse fark etmiyor. Bu ekran o kombinasyonların tamamını tek görünümde veriyor;
        "Git" düğmesi seçili cari/şube/tarih ile Sefer ekranına yönlendiriyor ve kullanıcı
        doğrudan "Referans Grubu Oluştur"a basabilir hale geliyor.

        Backend detayları için: NetsisService.GetPendingReferenceGroups + PendingReferenceGroupRequestModel
    -->
    <b-card>
        <div class="row">
            <div class="col-md-4 mb-1">
                <label class="form-label">Tarih Aralığı</label>
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Şube <small class="text-muted">(hepsi için boş bırakın)</small></label>
                <v-select-list v-model="sube" :options="subeList" label="BranchName" placeholder="Şube"></v-select-list>
            </div>
        </div>

        <div class="row justify-content-end">
            <div class="col-auto mb-1 mb-md-0">
                <v-executer :loading="loading" :action="loadList">Yenile</v-executer>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <h2 class="d-flex align-items-center">
                    Bekleyen Referans Grupları
                    <b-badge variant="light-warning" class="ml-1" v-if="items.length > 0">
                        {{ items.length }} kombinasyon
                    </b-badge>
                </h2>
                <div class="table-responsive">
                    <table class="table table-sm align-middle">
                        <thead>
                            <tr>
                                <th class="text-nowrap">Hafta</th>
                                <th class="text-nowrap">Dönem</th>
                                <th class="text-nowrap">Nakliyeci</th>
                                <th class="text-nowrap">Şube</th>
                                <th class="text-right text-nowrap">Sefer Sayısı</th>
                                <th class="text-right text-nowrap">Toplam Tonaj</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(row, index) in items">
                                <tr :key="index">
                                    <td class="text-nowrap"><b-badge variant="light-secondary">H{{ row.Hafta }}</b-badge></td>
                                    <td class="text-nowrap">{{ row.DonemStr }}</td>
                                    <td class="text-nowrap" :title="row.TasiyiciCariKodu">{{ row.TasiyiciCariAdi || row.TasiyiciCariKodu }}</td>
                                    <td class="text-nowrap" :title="row.SubeKodu">{{ row.SubeAdi || row.SubeKodu || '-' }}</td>
                                    <td class="text-right text-nowrap">{{ row.SeferSayisi }}</td>
                                    <td class="text-right text-nowrap">{{ row.ToplamTonajStr }}</td>
                                    <td class="text-right text-nowrap">
                                        <!-- "Git": Sefer ekranını cari + şube + hafta ile aç.
                                             Query param'ları VoyageView.mounted okur; filter()
                                             otomatik çalışır, kullanıcı doğrudan
                                             "Referans Grubu Oluştur" düğmesine geçer. -->
                                        <b-button size="sm" variant="primary" v-on:click="openInVoyage(row)">
                                            <feather-icon icon="ArrowRightCircleIcon" class="mr-25"></feather-icon>
                                            Git
                                        </b-button>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="!loading && items.length === 0">
                                <td colspan="100" class="text-center py-3 text-success">
                                    <feather-icon icon="CheckCircleIcon" class="mr-25"></feather-icon>
                                    Bu tarih aralığında bekleyen bir kombinasyon yok — hepsi gruplanmış görünüyor.
                                </td>
                            </tr>
                            <tr v-if="loading">
                                <td colspan="100" class="text-center py-3">
                                    <b-spinner small></b-spinner>
                                    <span class="ml-1">Yükleniyor...</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard, BButton, BBadge, BSpinner } from 'bootstrap-vue'
import { NetsisApi } from '@/api/netsis'
import moment from 'moment'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
    components:{
        BCard, BButton, BBadge, BSpinner, FeatherIcon
    },
    data(){
        return {
            // Varsayılan: son 2 ay. Adam Excel'inde hafta bazlı kayıtları takip ediyor;
            // bir aydan kısa bir pencere fazla dar olabilir.
            queryData:{
                StartDate: moment().subtract(2,'months').startOf('month').format('YYYY-MM-DD'),
                EndDate:   moment().endOf('month').format('YYYY-MM-DD'),
                BranchCode: null,
            },
            subeList:[],
            items:[],
            loading:false,
        }
    },
    mounted(){
        this.getSubeList()
        this.loadList()
    },
    methods:{
        getSubeList(){
            NetsisApi.GetSubeList().then(res => {
                if(res.data?.Success) this.subeList = res.data.Data || []
            }).catch(() => {})
        },
        loadList(){
            this.loading = true
            NetsisApi.GetPendingReferenceGroups(this.queryData).then(res => {
                if(res.data?.Success){
                    this.items = res.data.Data || []
                }else{
                    this.$result(res)
                    this.items = []
                }
                this.loading = false
            }).catch(err => {
                this.$result(null, err)
                this.loading = false
            })
        },
        openInVoyage(row){
            // Şube adını da query'ye koyuyoruz ki dropdown ilk render'da doğru etiketi göstersin
            // (dropdown seçenek listesi asenkron yükleniyor, VoyageView stub kayıt ekleyerek
            // görünürlüğü sağlıyor).
            this.$router.push({
                name: 'voyage',
                query: {
                    cari:     row.TasiyiciCariKodu,
                    cariAdi:  row.TasiyiciCariAdi,
                    sube:     row.SubeKodu,
                    subeAdi:  row.SubeAdi,
                    start:    row.HaftaBaslangicStr,
                    end:      row.HaftaBitisStr,
                }
            })
        }
    },
    computed:{
        date:{
            get(){
                return [this.queryData.StartDate, this.queryData.EndDate].filter(d => d != null)
            },
            set(val){
                this.queryData.StartDate = val[0] || null
                this.queryData.EndDate   = val[1] || null
            }
        },
        sube:{
            get(){ return this.subeList.find(s => s.BranchCode === this.queryData.BranchCode) },
            set(v){ this.queryData.BranchCode = v?.BranchCode || null }
        }
    }
}
</script>

<style scoped>
</style>
